import { SHOW_ALL_ITEMS_QUANTITY } from '@/shared/config';

export const RECORD_QUANTITY_OPTIONS = [
  { id: 10, name: '10 por página' },
  { id: 25, name: '25 por página' },
  { id: 50, name: '50 por página' },
  { id: SHOW_ALL_ITEMS_QUANTITY, name: 'Todos os registros' },
];

export const DEFAULT_RECORD_PAGE_SIZE = 10;

/**
 * Batch size the "Todos os registros" mode requests per scroll. It is not injected anywhere: the
 * shared revisions store fixes its own batch at 30 (`createDocumentRevisionsStore`), so this is the
 * documented expectation the modal's test holds the store to. Changing one without the other turns
 * the test red, which is the point.
 */
export const RECORD_INFINITE_SCROLL_BATCH_SIZE = 30;
